import { render, staticRenderFns } from "./StageCorrectPathway.vue?vue&type=template&id=21617ea1&"
import script from "./StageCorrectPathway.vue?vue&type=script&lang=js&"
export * from "./StageCorrectPathway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports